import * as React from 'react'
import styled from '@emotion/styled'
import { Primary } from '@sphinx/components-styles'

interface SliderHandleProps {
  isVertical: boolean
}

const SliderHandler = styled.button<SliderHandleProps>`
  cursor: ${({ isVertical }) => (isVertical ? 'row-resize' : 'col-resize')};
  position: absolute;
  left: -3px;
  padding: 0;
  border-color: transparent;
  background-color: transparent;
  height: 25px;
  border-radius: 3px;

  &:hover {
    border-color: ${Primary.orange[100]};
  }

  &:focus {
    border-color: ${Primary.orange[100]};
    outline: none;
  }

  &:active {
    border-color: transparent;

    & > svg > rect {
      fill: ${Primary.orange[100]};
    }
  }
`

export const SliderHandle: React.FC<SliderHandleProps> = ({ isVertical }) => (
  <SliderHandler isVertical={isVertical} tabIndex={-1}>
    <svg
      width="5"
      height="23"
      viewBox="0 0 5 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="5" height="23" rx="2" fill="#163250" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5H3.25V7.5H2V5ZM2 8.75H3.25V11.25H2V8.75ZM2 12.5H3.25V15H2V12.5ZM2 16.25H3.25V18.75H2V16.25Z"
        fill="white"
      />
    </svg>
  </SliderHandler>
)
